import {
  getCookie,
  setCookie,
  delCookie
} from './auth';

//token
export function getToken() {
  return getCookie('mtoken')
}
export function setToken(token, expire) {
  return setCookie('mtoken', token, expire)
}
export function removeToken() {
  return delCookie('mtoken')
}
function getQueryString(name) {
  var href = window.location.href;
  let path = href.split('//')[1].split('/')[1];
  return path
}


// 用户ID
export function getUserId() {
  var userId = getCookie('muser_id')
  var id = getQueryString( );
  // console.log(id)
    if  (userId == ''){
    if (id != 'login' && id != ''&& id.indexOf('anotherToken')==-1){
      alert('登录信息已过期，请重新登录！')
      // console.log('打印出来了')
    }
  
  }else {
    return userId
  }
}
export function setUserId(user_id) {
  return setCookie('muser_id', user_id)
}
export function removeUserId() {
  return delCookie('muser_id')
}

// 用户登录名
export function getUserLogin() {
  return getCookie('muser_login')
}
export function setUserLogin(user_login) {
  return setCookie('muser_login', user_login)
}
export function removeUserLogin() {
  return delCookie('muser_login')
}

// 用户等级
export function getUserGrade() {
  return getCookie('muser_grade')
}
export function setUserGrade(user_grade) {
  return setCookie('muser_grade', user_grade)
}
export function removeUserGrade() {
  return delCookie('muser_grade')
}

// 用户等级名
export function getGradeName() {
  return getCookie('mgrade_name')
}
export function setGradeName(grade_name) {
  return setCookie('mgrade_name', grade_name)
}
export function removeGradeName() {
  return delCookie('mgrade_name')
}

// 店铺链接
export function getShopUrl() {
  return getCookie('mshop_url')
}
export function setShopUrl(shop_url) {
  return setCookie('mshop_url', shop_url)
}
export function removeShopUrl() {
  return delCookie('mshop_url')
}

// 是否开启橱窗
export function setWindow(cate_window) {
  return setCookie('mcate_window',cate_window)
}
export function getWindow() {
  return getCookie('mcate_window')
}
export function removeWindow() {
  return delCookie('mcate_window')
}

// 获取账号审核状态
export function setUserStatus(user_status) {
  return setCookie('muser_status',user_status)
}
export function getUserStatus() {
  return getCookie('muser_status')
}
export function removeUserStatus() {
  return delCookie('muser_status')
}

// 材云发显隐
export function setCyf(cyf_switch) {
  return setCookie('mcyf_switch',cyf_switch)
}
export function getCyf() {
  return getCookie('mcyf_switch')
}
export function removeCyf() {
  return delCookie('mcyf_switch')
}

// 通知中心红点控制
export function setNotice(msg_count) {
  return setCookie('mmsg_count',msg_count)
}
export function getNotice() {
  return getCookie('mmsg_count')
}
export function removeNotice() {
  return delCookie('mmsg_count')
}

// 实地商家标志
export function setProd(prod_status) {
  return setCookie('mprod_status',prod_status)
}
export function getProd() {
  return getCookie('mprod_status')
}
export function removeProd() {
  return delCookie('mprod_status')
}


// 当前页描述
export function setMetatitle(meta) {
  return setCookie('meta',meta)
}
export function getMetatitle() {
  return getCookie('meta')
}

// 店铺分弹框
// 获取
export function getGradeAlert() {
  return getCookie('mgradeflag')
}

// 设置
export function setGradeAlert(token, expire) {
  return setCookie('mgradeflag', token, expire)
}

// 删除
export function removeGradeAlert() {
  return delCookie('mgradeflag')
}


// WEBPACK FOOTER //
// ./src/utils/http.js